export default __webpack_public_path__ + "static/media/img_step_lucia10_m.2e494306.jpg";